const removeNullProperties = object => {
  for (let key in object) {
    if (object[key] === null || object[key] === undefined) {
      delete object[key];
    }
  }
};

export default removeNullProperties;
